// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"f6ba279c","422":"1a6a105d","667":"af14806e"}[chunkId] + ".chunk.js";
};